import DataTablePagination from "./DataTablePagination";
import FillEmpty from "./FillEmpty";
import ItemListDirective from "./ItemListDirective";

export default angular
.module("biznet.datatable", [])
.directive("pagination", DataTablePagination)
.directive("fillEmpty", FillEmpty)
.directive("itemList", ItemListDirective)
.directive("grid", function($timeout){
  return {
    restrict: "A",
    scope: {
      "source": "="
    },
    link: function(scope, element, attr){
      var rowHeight = 10;
      var preload = 10;
      var update = function(){
        var rows = element.find("tbody tr");
        var bodyHeight = element.find("tbody").height();
        rowHeight = bodyHeight / rows.length || 10;
        var marginTop = rowHeight*(scope.source.activeOffset);
        var marginBottom = Math.max(0,rowHeight*scope.source.totalResults - marginTop - bodyHeight);
        element.find("tbody")
          .css("margin-top", marginTop+"px")
          .css("margin-bottom", marginBottom+"px");
      };
      var debounceTimer;
      scope.$watch("source.draw", update);
      scope.$watch("source.working", function(isWorking){
        if(isWorking) $(element).addClass("loading")
        else $(element).removeClass("loading");
      });
      element.parent().on("scroll", function(e){
        if(debounceTimer) $timeout.cancel(debounceTimer)
        debounceTimer = $timeout(function(){
          var oldOffset = scope.source.offset;
          var oldLimit = scope.source.limit;
          debounceTimer = null;
          scope.source.offset = Math.max(0,Math.floor(element.parent().scrollTop()/rowHeight)-preload);
          scope.source.limit = Math.ceil(2*preload + element.parent().height()/rowHeight);
          if(scope.source.offset != oldOffset || scope.source.limit != oldLimit) scope.source.load();
        }, 50);
      });
    },
    controller: function($scope){
      this.toggleSort = (key) => {
        var sorting = [];
        var oldDir = undefined;
        ($scope.source.order||[]).forEach(item => {
          if(item.column == key){
            oldDir = item.dir;
          }else{
            sorting.push(item);
          }
        });
        if(oldDir === undefined){
          sorting.push({column: key, dir: true});
        }else if(oldDir === true){
          sorting.push({column: key, dir: false});
        }
        $scope.source.setOrder(sorting).load();
      };
      this.getSource = () => $scope.source;
      this.soruce = $scope.source;
    }
  }

})
.directive("gridSort", function(){
  return {
    restrict: "A",
    require: '^^grid',
    transclude: true,
    scope: {},
    link: function(scope, element, attr, gridCtrl){
      var key = attr.gridSort;
      element.on("click", function(){
        gridCtrl.toggleSort(key);
      });
      scope.source =  gridCtrl.getSource();
      scope.$watch("source.order", function(order){
        order = order || [];
        scope.isSortedAsc = false;
        scope.isSortedDesc = false;
        order.filter(sortItem => sortItem.column == key).forEach(sortItem => {
          if(sortItem.dir){
            scope.isSortedAsc = true;
          }else{
            scope.isSortedDesc = true;
          }
        })
        scope.isNotSorted = !(scope.isSortedAsc || scope.isSortedDesc);
      })
    },
    template: "<ng-transclude></ng-transclude> <i class='fa fa-sort-up' ng-if='isSortedAsc'></i><i class='fa fa-sort-down' ng-if='isSortedDesc'></i><i class='fa fa-sort' ng-if='isNotSorted'></i>"
  };
})
.name


// WEBPACK FOOTER //
// ./src/DataTable/index.js